
const SkynetForm = ({ children, title }) => {
    return (
        <form className="skynet-form" role="form">
            {title && <h2 className="skynet-form-title">{title}</h2>}
            {children}
        </form>
    );
}

const FieldSet = ({ children, legend }) => {
    return (
        <fieldset>
            {legend && <legend className="skynet-form-legend">{legend}</legend>}
            {children}
        </fieldset>
    );
}

const FormGroup = ({ children, label }) => {
    return (
        <div className="form-group">
            {label && <label className="control-label">{label}</label>}
            {children}
        </div>
    )
}
            
FieldSet.FormGroup = FormGroup;
SkynetForm.FieldSet = FieldSet;

export default SkynetForm;